import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const ONBOARDING_KEY = 'wwi_drag_hint_shown';

export const DragHint = () => {
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    // Check if hint has been shown before
    const hasShown = localStorage.getItem(ONBOARDING_KEY);
    if (!hasShown) {
      // Show after 2 minutes of using the app
      const timer = setTimeout(() => {
        setShowHint(true);
      }, 120000); // 2 minutes = 120,000ms
      return () => clearTimeout(timer);
    }
  }, []);

  const dismissHint = () => {
    localStorage.setItem(ONBOARDING_KEY, 'true');
    setShowHint(false);
  };

  return (
    <AnimatePresence>
      {showHint && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-24 md:bottom-44 left-1/2 -translate-x-1/2 z-50"
          data-testid="drag-hint"
        >
          <div className="bg-[#27272A] text-white px-5 py-3 rounded-full shadow-lg flex items-center gap-3">
            <p className="text-sm">
              Click or drag tasks to other columns.
            </p>
            <button
              onClick={dismissHint}
              className="p-1 hover:bg-white/20 rounded-full transition-colors"
              aria-label="Dismiss hint"
            >
              <X size={14} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DragHint;
